const NoSmoking = (props) => (
  <svg
    fill="#ffffff"
    width="30px"
    height="30px"
    viewBox="0 0 296.832 296.832"
    {...props}
  >
    <g>
      <path d="M288.416,115.416H192.73L294.488,13.657c3.124-3.125,3.124-8.189,0-11.314c-3.125-3.123-8.19-3.123-11.315,0 
        L170.101,115.416H8.416c-4.418,0-8.333,3.582-8.333,8v50c0,4.418,3.915,8,8.333,8h95.686L2.343,283.174 
        c-3.124,3.125-3.124,8.189,0,11.314c1.563,1.562,3.609,2.343,5.657,2.343c2.048,0,4.095-0.781,5.657-2.343L126.73,181.416h161.686 
        c4.418,0,7.667-3.582,7.667-8v-50C296.083,118.998,292.834,115.416,288.416,115.416z M73.083,131.416h81.018l-34,34H73.083V131.416z 
        M176.73,131.416h71.353v34H142.73L176.73,131.416z"/>
    </g>
  </svg>
);

export default NoSmoking;
